import { DocData } from "../model/docData";

/** Статус договора для страницы «Договоры» (карточка и таблица). */
export function getContractConclusionStatus(doc: DocData): { text: string; color: string } {
    if (doc.needSecondSign) {
        const count = (doc.signed ? 1 : 0) + (doc.signedSecondSign ? 1 : 0);
        if (count === 0) {
            return { text: "Не заключен", color: "red" };
        }
        if (count === 1) {
            return { text: "Частично подписан", color: "orange" };
        }
        return { text: "Заключен", color: "green" };
    }
    if (doc.signed) {
        return { text: "Заключен", color: "green" };
    }
    return { text: "Не заключен", color: "red" };
}

/** Договор полностью заключён (все требуемые подписи есть). */
export function isContractFullyConcluded(doc: DocData): boolean {
    if (doc.needSecondSign) {
        return doc.signed && doc.signedSecondSign;
    }
    return doc.signed;
}
